export default __webpack_public_path__ + "static/media/colors.ba5657dd.jpg";